// Dependencies
import React from "react";
import { getMatchedRouteKeyValue } from "yarrr";
import { useSelector } from "react-redux";
import { endOfDay, getTime, parse } from "date-fns";
import { List } from "immutable";

// Components
import Request from "Components/Request";
import Spinner from "Components/Spinner";

// Hooks
import useRequest from "Hooks/useRequest";

// styles
import css from "./SlowQueries.styl";

const pageSize = 250;

const SlowQueries = () => {
	const dateString = useSelector((state) => getMatchedRouteKeyValue(state, "date", null));
	const timeZoneOffsetMilliseconds = useSelector((state) =>
		getMatchedRouteKeyValue(state, "timeZoneOffsetMilliseconds", 0)
	);

	// get date object from date string
	const formattedDate = parse(dateString, "yyyy-MM-dd", new Date());

	// get start and end of day by adding timezone offset
	const start = getTime(formattedDate) + Number(timeZoneOffsetMilliseconds);
	const end = getTime(endOfDay(new Date(start))) + Number(timeZoneOffsetMilliseconds);

	const { data, isRequesting } = useRequest("GetRequests", {
		limit: pageSize,
		skip: 0,
		filters: {
			startTime: start / 1000,
			endTime: end / 1000,
			sort: "-delta_time",
		},
	});

	const requestList = data ? data.get("requests") : List();

	return (
		<div className={css.main}>
			<h1>Slow Queries</h1>

			{isRequesting && <Spinner />}
			{requestList.size
				? requestList.map((request) => <Request key={request.get("id")} request={request} />)
				: null}
		</div>
	);
};

export default SlowQueries;
